/* ==========================================================================
 *  More text show
 * ======================================================================= */
function fn_parts_more_text(){
	if ($('.more-text').length){
        $(".more-text").bind('click', function () {
	        $(this).hide().next().addClass('active');
	    });
	}
}